import { TextField } from '@material-ui/core';

import PhoneNumberField from '../../../shared/components/Forms/PhoneNumberField.component';
import { DeliveryPointDetails } from '../../types/delivery-point-details.type';
import { DeliveryPointFieldChange } from '../../hooks/use-delivery-point-edit-form.hook';
import { DeliveryPointCard } from './DeliveryPointCard.component';

type Props = {
  updatedDeliveryPoint: DeliveryPointDetails;
  onFieldChange: (change: DeliveryPointFieldChange) => void;
};

export function DeliveryPointContactCard({ updatedDeliveryPoint, onFieldChange }: Props) {
  return (
    <DeliveryPointCard title="Contact">
      <PhoneNumberField
        id="delivery-point-phone"
        value={updatedDeliveryPoint.phone ?? ''}
        onChange={(digits) => onFieldChange({ field: 'phone', value: digits })}
      />
      <TextField
        id="delivery-point-email"
        label="Email"
        type="email"
        size="small"
        variant="outlined"
        value={updatedDeliveryPoint.email ?? ''}
        onChange={(event) => onFieldChange({ field: 'email', value: event.target.value })}
      />
      <TextField
        id="delivery-point-website"
        label="Site web"
        type="text"
        size="small"
        variant="outlined"
        value={updatedDeliveryPoint.website ?? ''}
        onChange={(event) => onFieldChange({ field: 'website', value: event.target.value })}
      />
    </DeliveryPointCard>
  );
}
